import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class IdVerificationService {
  private url = environment.nodeApi; 
  private ehurl = environment.apiUrl; 

  headers = { headers: { headerType: 'incode' }}


  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) { }

  get token() {
    return this.sessionService.getSession('incodeToken') || '';
  }

  getHeaders(token: any) {
    return {
      headers: { 
        headerType: 'incode',
        token: token
      }
    }
  }

  login(): Observable<any> {
    return this.http.get(`${this.url}/id-verification/login`)
    .pipe(
      map(
        (data: any) => {
          if(data) {
            this.sessionService.setSession('incodeToken', data.token);
            this.sessionService.setSession('incodeRefreshToken', data.refreshToken);

            // sessionStorage.setItem('incodeToken', data.token)
            // sessionStorage.setItem('incodeRefreshToken', data.refreshToken)
          }
          return data;
        }
      )
    ) 
  }

  fetchScores(sessionId: any): Observable<any> {
    return this.http.post(`${this.url}/id-verification/fetch-scores`, {sessionId: sessionId}, this.getHeaders(this.token));
  }

  fetchImages(sessionId: any): Observable<any> {
    return this.http.post(`${this.url}/id-verification/fetch-images`, {sessionId: sessionId}, this.getHeaders(this.token));
  }

  fetchOcr(sessionId: any): Observable<any> {
    return this.http.post(`${this.url}/id-verification/fetch-ocr`, {sessionId: sessionId}, this.getHeaders(this.token));
  }

  fetchDeviceInfo(sessionId: any): Observable<any> {
    return this.http.post(`${this.url}/id-verification/fetch-device-info`, {sessionId: sessionId}, this.getHeaders(this.token));
  }

  fetchSessionData(sessionId: any): Observable<any> {
    return this.http.post(`${this.url}/id-verification/fetch-session-data`, {sessionId: sessionId}, this.getHeaders(this.token));
  }

  udpateManualReview(sessionId: any, manualReviewStatus: 'REQUIRED' | 'APPROVED' | 'REJECTED', newReason?: string): Observable<any> {
    return this.http.post(`${this.url}/id-verification/update-manual-review`, {sessionId: sessionId, manualReviewStatus: manualReviewStatus, newReason: newReason}, this.getHeaders(this.token));
  }


  sendIdVerificationLinkEmail(candidateId:string, email: string){
    return this.http.post(`${this.ehurl}/EzyhireCandidateController/sendIdVerificationLink/${email}/${candidateId}`, {});
  }

  fetchSessionDetails(uuId: any) {
    return this.http.post(`${this.url}/id-verification/fetch-same-session`, {uuid: uuId});
  }

  fetchOnboardingStatus(sessionId: any): Observable<any> {
    return this.http.post(`${this.url}/id-verification/fetch-onboarding-status`, {sessionId: sessionId}, this.getHeaders(this.token));
  }

  updateVerificationStatus(data: any) {
    return this.http.post(`${this.ehurl}/startTest/updateVerificationStatusAndLicense`, data);
  }

  getBgvOrderBySessionId(idvSessionId: any) {
    return this.http.get(`${this.ehurl}/BackgroundVerificationController/getBGVOrderBySessionId/${idvSessionId}`);
  }
}



 
  
